export default __webpack_public_path__ + "static/media/list-of-inputs.5c607656.svg";